import EnumType from "../models/EnumType";

export default function defaultUndefinedEnum<T, N>(
  enumValue: EnumType<keyof T> | null | undefined,
  def: N,
): keyof T | N {
  return enumValue || def;
}
